import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class AdminRepository extends EntityBaseRepository {

    /**
     * Deletes three static tables from the database
     * @returns Promise<AxiosResponse>
     */
    public deleteStaticTables(): Promise<AxiosResponse> {
        return this.axiosClient.delete('/admin/static-tables');
    }

    /**
     * Alternative method to delete specific static tables
     * @param tableNames Array of table names to delete
     * @returns Promise<AxiosResponse>
     */
    public deleteSpecificStaticTables(tableNames: string[]): Promise<AxiosResponse> {
        return this.axiosClient.delete('/admin/static-tables', {
            data: { tableNames }
        });
    }
}